/*Sage Custom Code Start (Aug 2026)*/
/* Added some js functionality */


import { Component } from '@theme/component';
import { VariantSelectedEvent, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { requestYieldCallback } from '@theme/utilities';








/**
 * A custom element that manages a variant picker.
 *
 * @template {import('@theme/component').Refs} [Refs = {}]
 *
 * @extends Component<Refs>
 */
export default class VariantPicker extends Component {
  /** @type {string | undefined} */
  #pendingRequestUrl;

  /** @type {AbortController | undefined} */
  #abortController;





  

  /** @type {boolean} */
  #sizeWasSelected = false;

  /** @type {boolean} */
  #sizeWasExplicitlyClicked = false;

  /** @type {string | null} */
  #selectedSizeOptionValueId = null;

  /** @type {boolean} */
  #initialSizeTextHidden = false;

  /** @type {number | undefined} */
  #restoreAddToCartTimer;

  /** @type {boolean} */
  #isInitialLoad = true;









  





  connectedCallback() {
    super.connectedCallback();





    this.addEventListener('change', this.variantChanged.bind(this));

    this.initializeSizeDisplay();
    this.updateOptionValueDisplay();
    this.updateSizeAndAddToCartState(true);
  }



disconnectedCallback() {
  super.disconnectedCallback();

  

  this.#abortController?.abort();
  clearTimeout(this.#restoreAddToCartTimer);
}




  
  initializeSizeDisplay() {
  const fieldsets = Array.from(
    this.querySelectorAll('fieldset')
  );

  const colorFieldset = fieldsets.find((fieldset) =>
    fieldset
      .querySelector('legend')
      ?.textContent
      .trim()
      .startsWith('Color')
  );

  const sizeFieldset = fieldsets.find((fieldset) =>
    fieldset
      .querySelector('legend')
      ?.textContent
      .trim()
      .startsWith('Size')
  );

  /*
   * Always select the first Color on a fresh page load/navigation.
   */
  if (colorFieldset) {
    const colorInputs = colorFieldset.querySelectorAll(
      'input[type="radio"]'
    );

    colorInputs.forEach((input) => {
      if (input instanceof HTMLInputElement) {
        input.checked = false;
      }
    });

    const firstColorInput =
      colorFieldset.querySelector(
        'input[type="radio"]'
      );

    if (firstColorInput instanceof HTMLInputElement) {
      firstColorInput.checked = true;
    }
  }

  /*
   * Always start with Size explicitly unselected.
   */
  if (sizeFieldset) {
    sizeFieldset
      .querySelectorAll('input[type="radio"]')
      .forEach((input) => {
        if (input instanceof HTMLInputElement) {
          input.checked = false;
        }
      });
  }
}






  hideInitialSizeText() {
    if (this.#initialSizeTextHidden) return;

    const addToCartButton = document.querySelector(
      'add-to-cart-component button[name="add"]'
    );

    if (!addToCartButton) return;

    const initialSizeText = addToCartButton.querySelector(
      '.add-to-cart-text__content--initial'
    );

    const dynamicSizeText = addToCartButton.querySelector(
      '.add-to-cart-text__content--dynamic'
    );

    if (!initialSizeText || !dynamicSizeText) return;

    addToCartButton.classList.add('variant-interacted');

    initialSizeText.style.display = 'none';
    dynamicSizeText.style.display = 'inline';

    this.#initialSizeTextHidden = true;
  }








restoreAvailableSizeAddToCartState() {
  if (
    !this.#sizeWasSelected ||
    !this.#selectedSizeOptionValueId
  ) {
    return;
  }

  const sizeInput = this.querySelector(
    `fieldset input[data-option-value-id="${this.#selectedSizeOptionValueId}"]`
  );

  if (!(sizeInput instanceof HTMLInputElement)) {
    return;
  }

  /*
   * Always restore the customer's explicitly selected Size,
   * even when that Size is sold out for the newly selected Color.
   *
   * updateSizeAndAddToCartState() will then decide whether
   * the button should say ADD TO BAG or NOTIFY ME.
   */
  sizeInput.checked = true;

  this.updateOptionValueDisplay();
  this.updateSizeAndAddToCartState(false);
}








    /**
   * Updates the Add to Cart button based on whether a size is selected.
   * @param {boolean} forceNoSize
   */
  updateSizeAndAddToCartState(forceNoSize = false) {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));

    const sizeFieldset = fieldsets.find((fieldset) =>
      fieldset.querySelector('legend')?.textContent.trim().startsWith('Size')
    );

    if (!sizeFieldset) return;

    const selectedSize = forceNoSize
      ? null
      : (
        this.#selectedSizeOptionValueId
            ? sizeFieldset.querySelector(
          `input[data-option-value-id="${this.#selectedSizeOptionValueId}"]`
              )
            : sizeFieldset.querySelector('input:checked')
        );

    const selectedSizeLabel = selectedSize?.closest('label');

    const validSizeSelected =
      selectedSize instanceof HTMLInputElement &&
      !selectedSize.disabled &&
      selectedSize.getAttribute('aria-disabled') !== 'true' &&
      selectedSizeLabel?.getAttribute('aria-disabled') !== 'true';

    const addToCartButton = document.querySelector(
      'add-to-cart-component button[name="add"]'
    );




const backInStockContainer = document.querySelector(
  '.back-in-stock-container'
);

const backInStockButton = document.querySelector(
  '[data-bis-button]'
);





    if (!addToCartButton) return;

    const addToCartText = addToCartButton.querySelector(
  '.add-to-cart-text__content--dynamic'
);

    if (!addToCartText) return;

const addToCartComponent = addToCartButton.closest(
  'add-to-cart-component'
);




if (validSizeSelected && addToCartComponent) {
  addToCartComponent.removeAttribute('disabled');
  addToCartComponent.classList.remove('sold-out');
  addToCartComponent.classList.remove('sold-out-state');
    }

const selectedSizeIsSoldOut =
  selectedSize instanceof HTMLInputElement &&
  (
    selectedSize.disabled ||
    selectedSize.getAttribute('aria-disabled') === 'true' ||
    selectedSize.closest('label')?.getAttribute('aria-disabled') === 'true'
  );

if (selectedSizeIsSoldOut) {
  const addToCartComponent = addToCartButton.closest(
    'add-to-cart-component'
      );

  addToCartComponent?.classList.add('notify-me-state');

  addToCartText.textContent = 'NOTIFY ME';

  addToCartButton.disabled = false;
  addToCartButton.classList.remove('select-size-required');

  addToCartButton.style.setProperty(
    'background-color',
    '#111111',
    'important'
    );

  addToCartButton.style.setProperty(
    'color',
    '#fff',
    'important'
      );

  return;
}

addToCartText.textContent = 'ADD TO BAG';






    /*
     * SIZE NOT SELECTED / SOLD OUT
   */

    if (!validSizeSelected) {

  if (
    this.#sizeWasSelected &&
    this.#selectedSizeOptionValueId
  ) {
    return;
  }

  addToCartButton.disabled = true;
  addToCartButton.classList.add('select-size-required');

  addToCartButton.style.setProperty(
    'background-color',
    'rgba(16,16,16,.5)',
    'important'
  );

  addToCartButton.style.setProperty(
    'color',
    '#fff',
    'important'
  );

  addToCartText.textContent = 'SELECT SIZE';

    return;
  }

    /*
     * AVAILABLE SIZE SELECTED
     */
       
   addToCartButton.disabled = false;
   addToCartButton.classList.remove('select-size-required');
   addToCartButton.classList.remove('sold-out-state');
   addToCartButton.style.removeProperty('background-color');
   addToCartButton.style.removeProperty('color');


addToCartComponent?.classList.remove('notify-me-state');


   addToCartText.textContent = 'ADD TO BAG';
}

  /**
   * Handles the variant change event.
   * @param {Event} event - The variant change event.
   */



  variantChanged(event) {
  if (!(event.target instanceof HTMLElement)) return;

  const selectedOption =



    event.target instanceof HTMLSelectElement
      ? event.target.options[event.target.selectedIndex]
      : event.target;

    if (!selectedOption) return;

    const fieldset = event.target.closest('fieldset');




    const isSizeSelection =
  event.target instanceof HTMLInputElement &&
  fieldset?.querySelector('legend')?.textContent.trim().startsWith('Size');

if (isSizeSelection) {
  this.hideInitialSizeText();
}






     /*
   * A size becomes permanently selected only when
   * the customer actually clicks a size.
   */
  if (isSizeSelection) {
    this.#sizeWasSelected = true;
    this.#sizeWasExplicitlyClicked = true;



  const clickedSize =
    event.target instanceof HTMLInputElement
      ? event.target
      : null;



  



  const clickedSizeLabel = clickedSize?.closest('label');

  const sizeIsUnavailable =
    !clickedSize ||
    clickedSize.disabled ||
    clickedSize.getAttribute('aria-disabled') === 'true' ||
    clickedSizeLabel?.getAttribute('aria-disabled') === 'true';

    /*
   * Remember the size that was explicitly clicked.
   */
  this.#selectedSizeOptionValueId =
    clickedSize?.dataset.optionValueId || null;

  this.#sizeWasSelected = true;

    /*
   * SOLD-OUT SIZE
     */
  if (sizeIsUnavailable) {

    const addToCartButton = document.querySelector(
      'add-to-cart-component button[name="add"]'
      );

    const backInStockContainer = document.querySelector(
      '.back-in-stock-container'
    );

    const backInStockButton = document.querySelector(
      '[data-bis-button]'
    );





        if (addToCartButton) {
      addToCartButton.disabled = true;
      addToCartButton.classList.add('select-size-required');

      addToCartButton.style.setProperty(
        'background-color',
        'rgba(16,16,16,.5)',
        'important'
      );

      addToCartButton.style.setProperty(
        'color',
        '#fff',
        'important'
      );

      const addToCartText = addToCartButton.querySelector(
        '.add-to-cart-text__content--dynamic'
    );

      if (addToCartText) {
        addToCartText.textContent = 'NOTIFY ME';
      }
    }





    /*
     * Show Notify Me only after the sold-out
     * size has actually been clicked.
     *
     * It starts disabled/grey while Shopify
     * performs the variant update.
     */
    if (backInStockContainer && backInStockButton) {
      backInStockContainer.hidden = false;
      backInStockButton.disabled = true;
      backInStockButton.textContent = 'NOTIFY ME';
    }

  } else {

    /*
     * AVAILABLE SIZE
     */
    this.updateSizeAndAddToCartState(false);

    /*
     * Hide Notify Me when an available size
     * is explicitly clicked.
     */
    const backInStockContainer = document.querySelector(
    '.back-in-stock-container'
  );

    const backInStockButton = document.querySelector(
    '[data-bis-button]'
  );

    if (backInStockContainer && backInStockButton) {
    backInStockContainer.hidden = true;
    backInStockButton.disabled = true;
  }
  }




} else {

  /*
   * COLOR / OTHER OPTION WAS CHANGED.
   *
   * Do NOT clear the customer's previously selected size.
   * The normal Shopify variant update should continue.
   */
}







    this.updateSelectedOption(event.target);

this.updateOptionValueDisplay();

/*
 * Update the button immediately for both Color and Size changes.
 */
this.updateSizeAndAddToCartState(false);




    this.dispatchEvent(
      new VariantSelectedEvent({
        id: selectedOption.dataset.optionValueId ?? '',
      })
    );

    const isOnProductPage =
      this.dataset.templateProductMatch === 'true' &&
      !event.target.closest('product-card') &&
      !event.target.closest('quick-add-dialog');

    const currentUrl = this.dataset.productUrl?.split('?')[0];
    const newUrl = selectedOption.dataset.connectedProductUrl;

    const loadsNewProduct =
      isOnProductPage &&
      !!newUrl &&
      newUrl !== currentUrl;

    this.fetchUpdatedSection(
      this.buildRequestUrl(selectedOption),
      loadsNewProduct
    );

    const url = new URL(window.location.href);

    const variantId = selectedOption.dataset.variantId || null;

    if (isOnProductPage) {
      if (variantId) {
        // url.searchParams.set('variant', variantId);
      } else {
        url.searchParams.delete('variant');
      }
    }

    if (loadsNewProduct) {
      url.pathname = newUrl;
    }

    if (url.href !== window.location.href) {
      requestYieldCallback(() => {
        history.replaceState({}, '', url.toString());
      });
    }
  }





/**
 * Updates the displayed Color/Size value immediately.
 */
updateOptionValueDisplay() {
  const fieldsets = Array.from(this.querySelectorAll('fieldset'));

  fieldsets.forEach((fieldset) => {
    const selectedInput = fieldset.querySelector(
      'input[type="radio"]:checked'
    );

    const valueElement = fieldset.querySelector(
      '.variant-option__swatch-value'
    );

    if (
      selectedInput instanceof HTMLInputElement &&
      valueElement instanceof HTMLElement
    ) {
      valueElement.textContent = selectedInput.value;
    }
  });
}





  /**
   * Updates the selected option.
   * @param {string | Element} target - The target element.
   */
  updateSelectedOption(target) {
    if (typeof target === 'string') {
      const targetElement = this.querySelector(`[data-option-value-id="${target}"]`);

      if (!targetElement) throw new Error('Target element not found');

      target = targetElement;
    }

    if (target instanceof HTMLInputElement) {
      target.checked = true;
    }

    if (target instanceof HTMLSelectElement) {
      const newValue = target.value;
      const newSelectedOption = Array.from(target.options).find((option) => option.value === newValue);

      if (!newSelectedOption) throw new Error('Option not found');

      for (const option of target.options) {
        option.removeAttribute('selected');
      }

      newSelectedOption.setAttribute('selected', 'selected');
    }
  }

  /**
   * Builds the request URL.
   * @param {HTMLElement} selectedOption - The selected option.
   * @param {string | null} [source] - The source.
   * @param {string[]} [sourceSelectedOptionsValues] - The source selected options values.
   * @returns {string} The request URL.
   */
  buildRequestUrl(selectedOption, source = null, sourceSelectedOptionsValues = []) {
    // this productUrl and pendingRequestUrl will be useful for the support of combined listing. It is used when a user changes variant quickly and those products are using separate URLs (combined listing).
    // We create a new URL and abort the previous fetch request if it's still pending.
    let productUrl = selectedOption.dataset.connectedProductUrl || this.#pendingRequestUrl || this.dataset.productUrl;
    this.#pendingRequestUrl = productUrl;
    const params = [];

    if (this.selectedOptionsValues.length && !source) {
      params.push(`option_values=${this.selectedOptionsValues.join(',')}`);
    } else if (source === 'product-card') {
      if (this.selectedOptionsValues.length) {
        params.push(`option_values=${sourceSelectedOptionsValues.join(',')}`);
      } else {
        params.push(`option_values=${selectedOption.dataset.optionValueId}`);
      }
    }

    // If variant-picker is a child of quick-add-component or swatches-variant-picker-component, we need to append section_id=section-rendering-product-card to the URL
    if (this.closest('quick-add-component') || this.closest('swatches-variant-picker-component')) {
      if (productUrl?.includes('?')) {
        productUrl = productUrl.split('?')[0];
      }
      return `${productUrl}?section_id=section-rendering-product-card&${params.join('&')}`;
    }
    return `${productUrl}?${params.join('&')}`;
  }

  /**
   * Fetches the updated section.
   * @param {string} requestUrl - The request URL.
   * @param {boolean} shouldMorphMain - If the entire main content should be morphed. By default, only the variant picker is morphed.
   */
  fetchUpdatedSection(requestUrl, shouldMorphMain = false) {
    // We use this to abort the previous fetch request if it's still pending.
    this.#abortController?.abort();
    this.#abortController = new AbortController();



    fetch(requestUrl, {
  signal: this.#abortController.signal,
  priority: 'high',
})




      .then((response) => response.text())
      .then((responseText) => {
        this.#pendingRequestUrl = undefined;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        // Defer is only useful for the initial rendering of the page. Remove it here.
        html.querySelector('overflow-list[defer]')?.removeAttribute('defer');

        const textContent = html.querySelector(`variant-picker script[type="application/json"]`)?.textContent;
        if (!textContent) return;

        if (shouldMorphMain) {
          this.updateMain(html);
        } else {
          const newProduct = this.updateVariantPicker(html);

          // We grab the variant object from the response and dispatch an event with it.
          
          




        if (this.selectedOptionId) {
          const variantData = JSON.parse(textContent);

  console.log(
    '[VariantPicker] VariantUpdateEvent fired:',
    variantData
  );

          this.dispatchEvent(
            new VariantUpdateEvent(
              variantData,
              this.selectedOptionId,
              {
                html,
                productId: this.dataset.productId ?? '',
                newProduct,
              }
            )
          );

          /*
   * Back-in-stock button:
   * Once the variant update has completed, activate
   * Notify Me for the sold-out size that was clicked.
           */
  const backInStockContainer = document.querySelector(
              '.back-in-stock-container'
            );

  const backInStockButton = document.querySelector(
              '[data-bis-button]'
            );

          if (
            backInStockContainer &&
            backInStockButton &&
    variantData?.available === false &&
            this.#sizeWasSelected &&
            this.#selectedSizeOptionValueId
          ) {
    backInStockContainer.hidden = false;
    backInStockButton.disabled = false;
    backInStockButton.textContent = 'NOTIFY ME';
          }




if (
  variantData?.available === false &&
  this.#sizeWasSelected &&
  this.#selectedSizeOptionValueId
) {
  const addToCartButton = document.querySelector(
    'add-to-cart-component button[name="add"]'
  );

  const addToCartText = addToCartButton?.querySelector(
    '.add-to-cart-text__content--dynamic'
  );

  const addToCartComponent = addToCartButton?.closest(
    'add-to-cart-component'
  );

  if (addToCartButton && addToCartText) {
    addToCartText.textContent = 'NOTIFY ME';

    addToCartButton.disabled = false;
    addToCartButton.classList.remove('select-size-required');

    addToCartButton.style.setProperty(
      'background-color',
      '#111111',
      'important'
    );

    addToCartButton.style.setProperty(
      'color',
      '#fff',
      'important'
    );

    addToCartComponent?.classList.add('notify-me-state');
  }
}




}






        }
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          console.warn('Fetch aborted by user');
        } else {
          console.error(error);
        }
      });
  }

  /**
   * @typedef {Object} NewProduct
   * @property {string} id
   * @property {string} url
   */

  /**
   * Re-renders the variant picker.
   * @param {Document} newHtml - The new HTML.
   * @returns {NewProduct | undefined} Information about the new product if it has changed, otherwise undefined.
   */
  updateVariantPicker(newHtml) {
    /** @type {NewProduct | undefined} */
    let newProduct;

    const newVariantPickerSource = newHtml.querySelector(this.tagName.toLowerCase());

    if (!newVariantPickerSource) {
      throw new Error('No new variant picker source found');
    }

    // For combined listings, the product might have changed, so update the related data attribute.
    if (newVariantPickerSource instanceof HTMLElement) {
      const newProductId = newVariantPickerSource.dataset.productId;
      const newProductUrl = newVariantPickerSource.dataset.productUrl;

      if (newProductId && newProductUrl && this.dataset.productId !== newProductId) {
        newProduct = { id: newProductId, url: newProductUrl };
      }

      this.dataset.productId = newProductId;
      this.dataset.productUrl = newProductUrl;
    }




  morph(this, newVariantPickerSource);



if (this.#sizeWasSelected && this.#selectedSizeOptionValueId) {




    const sizeInput = this.querySelector(
          `fieldset input[data-option-value-id="${this.#selectedSizeOptionValueId}"]`
        );

    if (sizeInput instanceof HTMLInputElement) {
        sizeInput.checked = true;
      }
    }

  


this.updateOptionValueDisplay();
this.restoreAvailableSizeAddToCartState();

return newProduct;
  }

  /**
   * Re-renders the entire main content.
   * @param {Document} newHtml - The new HTML.
   */
  updateMain(newHtml) {
    const main = document.querySelector('main');
    const newMain = newHtml.querySelector('main');

    if (!main || !newMain) {
      throw new Error('No new main source found');
    }

    morph(main, newMain);
  }

  /**
   * Gets the selected option.
   * @returns {HTMLInputElement | HTMLOptionElement | undefined} The selected option.
   */
  get selectedOption() {
    const selectedOption = this.querySelector('select option[selected], fieldset input:checked');

    if (!(selectedOption instanceof HTMLInputElement || selectedOption instanceof HTMLOptionElement)) {
      return undefined;
    }

    return selectedOption;
  }

  /**
   * Gets the selected option ID.
   * @returns {string | undefined} The selected option ID.
   */
  get selectedOptionId() {
    const { selectedOption } = this;
    if (!selectedOption) return undefined;
    const { optionValueId } = selectedOption.dataset;

    if (!optionValueId) {
      throw new Error('No option value ID found');
    }

    return optionValueId;
  }

  /**
   * Gets the selected options values.
   * @returns {string[]} The selected options values.
   */
  get selectedOptionsValues() {
    /** @type HTMLElement[] */
    const selectedOptions = Array.from(this.querySelectorAll('select option[selected], fieldset input:checked'));

    return selectedOptions.map((option) => {
      const { optionValueId } = option.dataset;

      if (!optionValueId) throw new Error('No option value ID found');

        return optionValueId;
    });
  }




  get sizeWasExplicitlyClicked() {
  return this.#sizeWasExplicitlyClicked;
  }



}

if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}
